import { LocationDto, LocationPhases } from '@/lib/locations/dto';
import { LocationCalendlyLinksDto } from '@/lib/locations/dto/location-calendly-links.dto';
import { adaptCalendlyLink } from '@/utils/calendly';

import { CalendlyLinkByTour, LocationFormActions, TourType } from './types';

type getActionProps = {
  phase: LocationPhases;
  isEarlyInPersonTourEnabled: boolean;
  calendlyLinks: LocationCalendlyLinksDto;
};

export function getAction({
  phase,
  isEarlyInPersonTourEnabled,
  calendlyLinks,
}: getActionProps): LocationFormActions {
  const isLaunchLocationWithoutEarlyInPersonTourAvailable =
    phase === LocationPhases.Launch &&
    (!isEarlyInPersonTourEnabled || !calendlyLinks.inPersonTour);

  if (isLaunchLocationWithoutEarlyInPersonTourAvailable) {
    return LocationFormActions.ScheduleCall;
  }

  if (phase === LocationPhases.Signed) {
    return LocationFormActions.GetNotified;
  }

  return LocationFormActions.GetStarted;
}

export function getCalendlyLinkByTourType(
  location: {
    calendlyLinks: LocationDto['calendlyLinks'];
  },
  tourType: TourType
) {
  return tourType === TourType.VIRTUAL
    ? location.calendlyLinks.phoneCall
    : location.calendlyLinks.inPersonTour;
}

export function getAvailableTourTypes(location: {
  calendlyLinks: LocationDto['calendlyLinks'];
}): CalendlyLinkByTour[] {
  return Object.values(TourType)
    .map(
      (type) =>
        ({
          type,
          calendlyLink: adaptCalendlyLink(
            getCalendlyLinkByTourType(location, type)
          ),
        } as CalendlyLinkByTour)
    )
    .filter(({ calendlyLink }) => !!calendlyLink);
}

const ACTIONS_ENABLING_PHYSICAL_TOUR = [
  LocationFormActions.GetStarted,
  LocationFormActions.General,
];

export function getDefaultTourType(
  availableTourTypes: CalendlyLinkByTour[] | null,
  action: LocationFormActions
) {
  if (
    ACTIONS_ENABLING_PHYSICAL_TOUR.includes(action) &&
    availableTourTypes?.some(({ type }) => type === TourType.IN_PERSON)
  ) {
    return TourType.IN_PERSON;
  }
  return TourType.VIRTUAL;
}

export function canSelectTourType(action: LocationFormActions) {
  return action === LocationFormActions.GetStarted;
}
